<template>
    <div class="form-group mt-2">
        <label class="form-label" for="cluster_id">
            Виберiть з випадаючого списку Кластер
        </label>
        <div class="" v-if="draw_items.length > 0">
            <v-select
                v-model="active_dep_id"
                id="cluster_id"
                class="imc_reasons"
                :reduce="item => item.id"
                label="name"
                :options="this.draw_items"
                :filterable="false"
            >
                <template slot="no-options">
                    Оберіть організацію
                </template>
                
                <template slot="option" slot-scope="option">
                    <div class="d-center">
                        {{ option.name }}
                        <div class="small">
                            {{ option.domain }}
                        </div>
                    </div>
                </template>
            </v-select>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
    name: "cluster_select",
    components : {
        vSelect
    },
    data() {
        return {
            is_load: false,
            items : [],
            current_item : null,
        }
    },
    
    props : {
        active_id : {
            type : Number,
            required : true
        },
        active_org_id : {
            type : Number,
            default : 0,
        }
    },
    
    created () {
        this.load_organizations();
    },
    
    methods : {
        async load_organizations() {
            this.items = [];
            await api.get('/regions').then(({data}) => {
                this.is_load = true;
                if(data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                this.is_load = false;
            });
        },
    },
    
    computed : {
        draw_items() {
            return this.items;
        },
        
        
        active_dep_id : {
            get() {
                if(parseInt(this.active_id) > 0) {
                    return this.active_id;
                }
                return null;
            },
            set(new_id) {
                this.$emit('on_item_set',new_id);
            }
        },
    }
}
</script>



<style scoped>

</style>